import { ReactNode } from 'react';
import { Stack, Content } from '@kinesis/bungle';
import { CenteredLayout } from '@/components/centered-layout';
import { ResponsiveMinMax } from './layout.styles';

const Layout = (props: LayoutProps) => {
  const { children, paddingMode } = props;
  return (
    <CenteredLayout>
      <ResponsiveMinMax>
        <Content
          padding='medium'
          sizing='fill-container'
          paddingMode={paddingMode}
        >
          <Stack space='medium'>{children}</Stack>
        </Content>
      </ResponsiveMinMax>
    </CenteredLayout>
  );
};

export type LayoutProps = {
  children: ReactNode;
  paddingMode?: 'equal' | 'extended';
};

export { Layout };
